module.exports = __webpack_public_path__ + "img/btn1.721b8821.png";